/**
 * Single source of truth for PPT/PDF export caps per subscription tier.
 * Mirrors backend/scripts/restore_production_tiers_final.py per_generation_limits
 * (ppt_generations, handout_generations). Keep these two in sync.
 *
 * IMPORTANT: these are LIFETIME caps — "first N lessons ever created" get an
 * export, enforced against total_lessons_ever (see backend lessons.py
 * download_lesson_asset) — NOT a monthly rolling quota.
 */

export const PLAN_ORDER = ['free', 'silver', 'gold', 'platinum', 'institutional'];

export const PLAN_LIMITS = {
  free:          { key: 'free',          name: 'Free',          price: 'Free',   original: null,      dot: '#94a3b8', ppt: 2,    pdf: 0    },
  silver:        { key: 'silver',        name: 'Silver',        price: '₹99',    original: '₹299',    dot: '#64748b', ppt: null, pdf: null },
  gold:          { key: 'gold',          name: 'Gold',          price: '₹249',   original: '₹599',    dot: '#f59e0b', ppt: 40,   pdf: 20,  popular: true },
  platinum:      { key: 'platinum',      name: 'Platinum',      price: '₹499',   original: '₹1,999',  dot: '#a855f7', ppt: 80,   pdf: 40   },
  institutional: { key: 'institutional', name: 'Institutional', price: 'Custom', original: null,      dot: '#0ea5e9', ppt: null, pdf: null },
};

/** null/undefined cap means unlimited (only true for Institutional). */
export const isUnlimited = (cap) => cap === null || cap === undefined;

export const formatCap = (cap) => (isUnlimited(cap) ? 'Unlimited' : `First ${cap} lesson${cap === 1 ? '' : 's'}`);

export const formatCapShort = (cap) => (isUnlimited(cap) ? 'Unlimited' : `First ${cap}`);

/**
 * Plans worth showing as an upgrade target for a user currently on `currentTierKey`.
 * Never suggests a downgrade or the user's current tier. Platinum users (already at
 * the top paid tier) are pointed only at Institutional.
 */
export function getUpgradeOptions(currentTierKey) {
  const key = (currentTierKey || 'free').toLowerCase();

  if (key === 'platinum' || key === 'institutional') {
    return [PLAN_LIMITS.institutional];
  }

  const idx = PLAN_ORDER.indexOf(key);
  const startIdx = Math.max(idx === -1 ? 0 : idx + 1, 1); // never offer 'free'
  return PLAN_ORDER.slice(startIdx, PLAN_ORDER.length - 1).map((k) => PLAN_LIMITS[k]);
}
